import React from 'react';
import { useGameStore } from '../store/gameStore';
import { X, AlertTriangle, Lightbulb, ShieldAlert, Lock } from 'lucide-react';

export const ActionBlockedModal: React.FC = () => {
  const blockedAction = useGameStore(state => state.blockedAction);
  const clearBlockedAction = useGameStore(state => state.clearBlockedAction);

  if (!blockedAction) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm animate-fade-in p-4">
      <div className="glass-panel p-1 rounded-2xl max-w-md w-full shadow-[0_0_60px_rgba(239,68,68,0.2)] animate-pop-in">
        <div className="bg-slate-950/80 rounded-xl overflow-hidden">
          
          {/* Header */}
          <div className="bg-ops-red/20 p-4 border-b border-ops-red/30 flex justify-between items-center relative overflow-hidden">
            {/* Striped Warning Pattern */}
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTS0xIDFhMiAyIDAgMCAxIDItMmwyIDJhMiAyIDAgMCAxLTIgMmwtMi0yeiIgZmlsbD0icmdiYSgyMzksNjgsNjgsMC4xKSIvPjwvc3ZnPg==')] opacity-50"></div>
            
            <div className="flex items-center gap-3 relative z-10">
              <div className="p-1.5 bg-ops-red/20 rounded border border-ops-red/50">
                <Lock className="w-4 h-4 text-ops-red" />
              </div>
              <h3 className="text-sm font-bold text-white uppercase tracking-widest font-mono">Access Denied</h3>
            </div>
            <button 
              onClick={clearBlockedAction}
              className="relative z-10 text-ops-red hover:text-white transition-colors p-1 hover:bg-ops-red/20 rounded"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6 space-y-6">
            
            {/* Reason */}
            <div className="flex items-start gap-4">
              <div className="bg-ops-red/10 p-3 rounded-lg shrink-0 border border-ops-red/20">
                <AlertTriangle className="w-6 h-6 text-ops-red" />
              </div>
              <div>
                <h4 className="text-xs font-bold text-ops-red uppercase tracking-wider mb-1.5 font-mono">Error: {blockedAction.reason}</h4>
                <p className="text-slate-400 leading-relaxed text-sm">
                  Action cannot be executed under current parameters.
                </p>
              </div>
            </div>

            {/* Tip */}
            {blockedAction.tip && (
              <div className="bg-ops-blue/10 border border-ops-blue/20 rounded-lg p-4 flex items-start gap-3.5 relative overflow-hidden">
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-ops-blue"></div>
                <Lightbulb className="w-5 h-5 text-ops-blue shrink-0 mt-0.5" />
                <div>
                  <h4 className="text-[10px] font-bold text-ops-blue uppercase tracking-widest mb-1.5 font-mono">Tactical Suggestion</h4>
                  <p className="text-slate-200 text-sm italic font-medium">
                    "{blockedAction.tip}"
                  </p>
                </div>
              </div>
            )}

            {/* Action Button */}
            <button 
              onClick={clearBlockedAction}
              className="w-full py-3 bg-slate-800 hover:bg-slate-700 border border-slate-600 hover:border-slate-500 rounded-lg text-slate-300 hover:text-white font-bold uppercase tracking-widest text-xs transition-all font-mono"
            >
              [ Acknowledge ]
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
